import { useContext, useEffect, useRef } from "react";

import { getMember } from "~/api";
import { AuthStateContext } from "~/modules/Router/Auth/contexts/AuthStateContext";
import { useAppDispatch } from "~/store";
import {
  setGlobalIsCommunityMember,
  setGlobalMember,
  setGlobalPolicyCodes,
  setUserId,
} from "~/store/globalSlice";

export const useUpdateGlobal = () => {
  const { daoId, memberId, userId } = useContext(AuthStateContext);
  const dispatch = useAppDispatch();

  const previousMemberInfo = useRef<{ daoId: string; memberId: string } | null>(
    null,
  );

  useEffect(() => {
    dispatch(setGlobalIsCommunityMember(Boolean(memberId)));
  }, [dispatch, memberId]);

  useEffect(() => {
    if (!daoId || !memberId) return;
    if (
      daoId !== previousMemberInfo.current?.daoId ||
      memberId !== previousMemberInfo.current?.memberId
    ) {
      getMember({ memberId }).then((result) => {
        dispatch(setGlobalMember(result.data));
        previousMemberInfo.current = { daoId, memberId };
        dispatch(
          setGlobalPolicyCodes(
            result.data.roleArray.flatMap(
              ({ policyCodeArray }) => policyCodeArray,
            ),
          ),
        );
      });
    }
  }, [daoId, dispatch, memberId]);

  useEffect(() => {
    dispatch(setUserId(userId));
  }, [dispatch, userId]);
};

/** @reference https://github.com/marpple/ciety-fe/blob/53fc06e8e2d38d9f2ef0e7137ea6754dd72033b3/src/context/global/index.tsx */
